import { E_ModelPartial } from "@/api/moudules/model.types";

const cn2ModelPartial = {
    '电机': E_ModelPartial.Motor,
    '风机': E_ModelPartial.Fans,
    '泵': E_ModelPartial.WaterPump,
    '皮带': E_ModelPartial.Belt,
    '压缩机': E_ModelPartial.AirPressure,
    '离心机': E_ModelPartial.Centrifugal,
    '齿轮箱': E_ModelPartial.Cogs,
    '非齿轮箱': E_ModelPartial.NoCogs,
    '辊子': E_ModelPartial.Roller,
    '其它': E_ModelPartial.Other,
    '真空泵': E_ModelPartial.PickupPump,
    '输送机': E_ModelPartial.ConveyerMachine,
    '破碎机': E_ModelPartial.CrushingMachine,
    '反应釜': E_ModelPartial.Reactor,
    '球磨机': E_ModelPartial.BallMill,
    '变压器': E_ModelPartial.Transformer,
    '振动筛': E_ModelPartial.VibratingScreen,
    '汽轮机': E_ModelPartial.SteamTurbine,
    '机床': E_ModelPartial.MachineTool,
    '水轮机': E_ModelPartial.WaterTurbine,
    '发电机': E_ModelPartial.Generator,
}
export function modelPartialFromString(s: string) {
    return cn2ModelPartial[s]
}

/**
 * $t('enum.E_EquipmentType.WaterPump')
 * $t('enum.E_EquipmentType.Motor')
 * $t('enum.E_EquipmentType.BeltDrivenWaterPump')
 * $t('enum.E_EquipmentType.Fans')
 * $t('enum.E_EquipmentType.ChainBeltDrivenFan')
 * $t('enum.E_EquipmentType.AirPressure')
 * $t('enum.E_EquipmentType.Centrifugal')
 * $t('enum.E_EquipmentType.BeltDrivenCentrifuge')
 * $t('enum.E_EquipmentType.TheGearBoxDrivesTheFan')
 */
export enum E_EquipmentType {
    /**
     * 水泵
     */
    WaterPump = 'WaterPump',
    /**
     * 电机
     */
    Motor = 'Motor',
    // 皮带驱动的水泵
    BeltDrivenWaterPump = 'BeltDrivenWaterPump',
    // 风机
    Fans = 'Fans',
    // 链式、皮带驱动的风机
    ChainBeltDrivenFan = 'ChainBeltDrivenFan',
    /**
     * 空压机
     **/
    AirPressure = 'AirPressure',
    // 离心机
    Centrifugal = 'Centrifugal',
    // 皮带驱动的离心机
    BeltDrivenCentrifuge = 'BeltDrivenCentrifuge',
    // 齿轮箱驱动风机
    TheGearBoxDrivesTheFan = 'TheGearBoxDrivesTheFan',
}

const cn2EquipmentType = {
    '水泵': E_EquipmentType.WaterPump,
    '电机': E_EquipmentType.Motor,
    '皮带驱动的水泵': E_EquipmentType.BeltDrivenWaterPump,
    '风机': E_EquipmentType.Fans,
    '链式、皮带驱动的风机': E_EquipmentType.ChainBeltDrivenFan,
    '压缩机': E_EquipmentType.AirPressure,
    '离心机': E_EquipmentType.Centrifugal,
    '皮带驱动的离心机': E_EquipmentType.BeltDrivenCentrifuge,
    '齿轮箱驱动风机': E_EquipmentType.TheGearBoxDrivesTheFan,
}

export function equipmentTypeFromString(s: string) {
    return cn2EquipmentType[s]
}


interface IModelParts {
    createBy: string
}

export function canEditModel(model: IModelParts) {    
    return model.createBy != 'system'
}

